import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faQuestion, faTrash } from "@fortawesome/free-solid-svg-icons"
import {  useNavigate, useParams } from 'react-router-dom'
import { memo } from 'react'
import useAuth from "../../hooks/useAuth"


const FinalQuestionSet = ({ finalQuestionSet }) => {
    const {groupId, type} = useParams()
    const { isTeacher, isAdmin, isStudent } = useAuth()






    const navigate = useNavigate()
  

    if (finalQuestionSet) {
        //const created = new Date(finalQuestionSet.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long' })
         const handleEdit = () => navigate(`/${type}/${groupId}/question-sets/final/${finalQuestionSet._id}`)
         const cellStatus = finalQuestionSet.active ? '' : 'table__cell--inactive'


         
   
  
        return (
            <tr className="table__row">
                <td className={`table__cell finalQuestionSet__title ${cellStatus}`}>{finalQuestionSet.title}</td>
                <td className={`table__cell finalQuestionSet__title ${cellStatus}`}>{finalQuestionSet.group?.name}</td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{ new Date( finalQuestionSet.fromDate).toLocaleString()}   </td>
                <td className={`table__cell userQuestion__title ${cellStatus}`}>{new Date(finalQuestionSet.toDate).toLocaleString()}  </td>
                <td className={`table__cell finalQuestionSet__actions ${cellStatus}`} >{finalQuestionSet.numUsers}</td>
                <td className={`table__cell finalQuestionSet__title ${cellStatus}`}>
                <div className='d-flex'>

                   <button
             className="icon-button table__button"
             onClick={handleEdit}
         >
             <FontAwesomeIcon icon={faPenToSquare} />
         </button>
      
         </div>   
                </td>
            </tr>
        )

    } else return null
}

const memoizedFinalQuestionSet = memo(FinalQuestionSet)

export default memoizedFinalQuestionSet